import { KatLitFilteredElement, register } from '../../shared/base';
import { KatBlueprintManageEntityList } from './';

/**
 * @component {kat-blueprint-manage-entity-list-identify} KatBlueprintManageEntityListIdentify Component used to place and filter components within the identify section.
 * @slot default Blueprint content for identify section.
 */
@register(KatBlueprintManageEntityList.slotMapping.identify.name)
export class KatBlueprintManageEntityListIdentify extends KatLitFilteredElement {
  constructor() {
    super(
      KatBlueprintManageEntityList.slotMapping.identify.name,
      KatBlueprintManageEntityList.slotMapping.identify.allowed
    );
  }
}
